import React, { useContext, useEffect, useMemo } from "react";
import SideNav from "ui/dashboard/sidenav";
import { AuthContext } from "context/AuthContext";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Modal from "ui/modal";
import SignalProvider from "context/SignalContext";
import DataContolerProvider from "context/DataControlerContext";
import SinglePcContolerProvider from "context/SinglePcManagerContext";
import DownloadingDocking from "ui/downloads/docking";
import SideviewProvider from "context/SideviewContext";
import { SlidingView } from "ui/components/sliding-view";
import { USER_ROLE } from "lib/constants";
import "../commonStyles.scss";
import { v4 } from "uuid";
const windowId = v4();
const worker = new SharedWorker(
  new URL("../../lib/sharedWorker.ts", import.meta.url),
);
// @ts-ignore
window.__downloadReadOnly = true;
export default function Layout() {
  const { user } = useContext(AuthContext);
  const [dockReadOnly, setDockReadOnly] = React.useState(true);
  const showDownloadDock = useMemo(() => {
    return (
      user.role === USER_ROLE.Customer ||
      user.role === USER_ROLE.SiteManager ||
      user.role === USER_ROLE.OrgAdmin ||
      user.role === USER_ROLE.ProjectManager
    );
  }, []);
  useEffect(() => {
    worker.port.start();
    worker.port.postMessage({ type: "connect", masterKey: windowId });
    worker.port.onmessage = (e) => {
      if (e.data.type === "readOnly") {
        setDockReadOnly(e.data.readOnly);
        // @ts-ignore
        window.__downloadReadOnly = e.data.readOnly;
      }
    };
    setInterval(() => {
      worker.port.postMessage({ type: "connect", masterKey: windowId });
    }, 1000);
    // return () => {
    //   worker.port.postMessage({ type: "close", windowId });
    // };
  }, []);
  return (
    <>
      <SignalProvider>
        <DataContolerProvider>
          <SinglePcContolerProvider>
            <SideviewProvider>
              <div className="flex h-screen flex-col md:flex-row md:overflow-hidden relative">
                <div className="w-full flex-none md:w-24">
                  <SideNav />
                </div>
                <div className="flex-grow overflow-y-auto flex flex-col bg-slate-50 ">
                  <Outlet />
                </div>
                {showDownloadDock && (
                  <div
                    className="absolute bottom-0 right-10"
                    style={{ zIndex: 100 }}
                  >
                    <DownloadingDocking />
                  </div>
                )}
                <SlidingView />
              </div>
              <Modal />
            </SideviewProvider>
          </SinglePcContolerProvider>
        </DataContolerProvider>
      </SignalProvider>
    </>
  );
}
